<template>
    <div class="selects_container" v-if="refsList">
        <div class="numbered_select">
            <div class="number_icon">1</div>
            <div class="select cats_select">
                <select v-model="localSelectedCat" @change="sendData">
                    <option :value="{}" v-if="isCustom" >{{ $t('components.inputs.refSelectByCat.allLabel') }}</option>
                    <option :value="{}" v-if="!isCustom" >{{ $t('components.inputs.refSelectByCat.chooseFamilyLabel') }}</option>
                    <option v-for="cat in catsList" :index="cat.id" :value="cat" >
                        <span v-if="isCustom">{{ cat.name }}</span>
                        <span v-else> {{ getCatName(cat) }} </span>
                    </option>
                </select>
            </div>
        </div>
        <div class="numbered_select">
            <div class="number_icon">2</div>
            <div class="select refs_select">
                <select v-model="localSelectedRef" :disabled="savenRefsByCat.length == 0" @change="sendData">
                    <option v-for="refItem in savenRefsByCat" :value="refItem">
                        <span v-if="isCustom">{{ refItem.name }}</span>
                        <span v-else> {{ getRefName(refItem) }} </span>
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'RefSelectByCat',
    props: {
        isCustom: {
            type: Boolean,
            default: false
        },
        selectedCatId: {
            default: null
        },
        selectedRefId: {
            default: null
        }
    },
    components: {},
    data(){
        return {
            inInit: true,
            localSelectedRef: {},
            localSelectedCat: {}
        }
    },
    mounted(){
        const refId = parseInt("" + this.selectedRefId + "")
        if (this.selectedCatId){
            const catIndex = this._.findIndex(this.catsList, (o) => { return o.id == this.selectedCatId })
            this.localSelectedCat = this.catsList[catIndex]
            if (refId){
                const refIndex = this._.findIndex(this.refsList, (o) => { return o.id == refId })
                this.localSelectedRef = this.refsList[refIndex]
            }
        }
    },
    computed: {
        refsList(){
            if (this.isCustom){
                return this.$store.state.RefStore.customRefs
            }else{
                return this.$store.state.RefStore.savenRefs
            }
        },
        catsList(){
            if (this.isCustom){
                return this.$store.state.RefStore.customCats
            }else{
                return this.$store.state.RefStore.savenCats
            }
        },
        savenRefsByCat(){
            if (this.localSelectedCat.id){
                console.log (this.localSelectedCat)
                return this.refsList.filter( (refItem) => {
                    return refItem.sight_ref_cat_id == this.localSelectedCat.id
                })
            }else{
                if(this.isCustom){
                    return this.refsList
                }else{
                    return []
                }
            }
        }
    },
    methods: {
        sendData(){
            const localSelectedCatId = this.localSelectedCat ? this.localSelectedCat.id : null
            const localSelectedRefId = this.localSelectedRef ? this.localSelectedRef.id : null
            this.$emit('SelectChanged', localSelectedCatId, localSelectedRefId, this.localSelectedRef, this.localSelectedCat)
        },
        getCatName(cat){
            return this.$i18n.t("refs.job_families." + cat.slug)
        },
        getRefName(refItem){
            return this.$i18n.t("refs.jobs." + refItem.slug)
        }
    },
    watch: {
        localSelectedCat: function(newVal, oldVal){
            if (this.inInit == false){
                this.localSelectedRef = {}
            }else{
                this.inInit = false
            }
        }
    }
}

</script>

<style lang="scss">
.selects_container{
    padding: 0 10px;
    display: flex;
    justify-content: space-around;
    margin-bottom: 50px;
    margin-top: 50px;
    .numbered_select{
        width:45%;
        display: flex;
        justify-content: center;
        align-items: center;
        .number_icon{
            background: $grey;
            width: 32px;
            min-width: 32px;
            max-width: 32px;
            height: 32px;
            line-height: 32px;
            border-radius: 100%;
            color: $white;
            font-weight: 600;
            margin-right: 8px;
        }
        .cats_select, .refs_select{
            flex:1;
            height: 40px;
            select{
                width: 100%;
                height: 40px;
            }
        }
    }
}
</style>